import React from "react";
import CatalogCollectionPage from "./CatalogCollectionPage";

export default function SessioniPage() {
  return (
    <CatalogCollectionPage
      collectionKey="sessioni"
      eyebrow="Servizi · Sessioni"
      title="Sessioni."
      description="Sessioni singole del progetto TIME. Contenuti in preparazione."
      testId="sessioni"
    />
  );
}
